import { PlanningsDeliveryEntity } from 'src/entities/PlanningsDelivery.entity';

export const UNASSIGNED_DELIVERY_COLOR = '#999999';
export const DEFAULT_DELIVERY_COLOR = '#1976d2';

export const planningDeliveryColor = (
  delivery: Pick<PlanningsDeliveryEntity, 'driverId' | 'driverColor'> | undefined,
): string => {
  if (!delivery) return DEFAULT_DELIVERY_COLOR;
  if (delivery.driverId == null) return UNASSIGNED_DELIVERY_COLOR;

  return delivery.driverColor || DEFAULT_DELIVERY_COLOR;
};
